import React from 'react';
import LookupText from '../Elements/LookupText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import JsxHelper from '../Helpers/JsxHelper';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';
import LongText from '../Elements/LongText';

export default class FraudHitEvaluatorItem
{
  constructor (item)
  {
    this.initialize(item);
  }

  async initialize (item)
  {
    this.FraudHitEvaluatorId = item.fraudHitEvaluatorId;
    this.ShopperId = item.shopperId;
    this.AccountStatusCode = item.accountStatusCode;
    this.ShopperEmail = item.shopperEmail;
    this.ShopperName = item.shopperName;
    this.FraudStatus = item.fraudStatus;
    this.CountryCode = item.countryCode;
    this.CountryName = item.countryName;
    this.PendingOnId = item.pendingOnId;
    this.PendingOnName = item.pendingOnName;
    this.FraudMatchCount = item.fraudMatchCount;
    this.ReportCount = item.reportCount;
    this.NotInvoicedReportCount = item.notInvoicedReportCount;
    this.LastStatusChangeDate = item.lastStatusChangeDate;
    this.FieldworkOfficeName = item.fieldworkOfficeName;
    this.IsMarkedRed = item.wasFlaggedBefore;
    this.Selected = false;
  }
  static NameOfTheIdField ()
  {
    return 'FraudHitEvaluatorId';
  }

  static nameOfTheItemDetailList ()
  {
    return 'Fraud Hit Evaluator';
  }

  static MoneyFields = [];

  static Currency ()
  {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return '';
  }

  static DateFields = [ 'LastStatusChangeDate' ];

  static BoolFields = [];

  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: FraudHitEvaluatorItem.getSelectedCellHeader,
        orderById: '',
        data: FraudHitEvaluatorItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Shopper ID',
        orderById: 'ShopperId',
        data: FraudHitEvaluatorItem.idFunction,
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      // {
      //   label: 'FraudHitEvaluatorId',
      //   orderById: 'FraudHitEvaluatorId',
      //   data: 'FraudHitEvaluatorId',
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 70,
      // },
      {
        label: 'Shopper Name',
        orderById: 'ShopperName',
        data: (item) => (
          <LongText
            text={item.ShopperName}
            maxLength={15}
          />
        ),
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Profile Email',
        orderById: 'ShopperEmail',
        data: (item) => JsxHelper.MailTo(item.ShopperEmail),
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Account Status',
        orderById: 'AccountStatusCode',
        data: (item) => (
          <LookupText
            lookupId={40}
            value={item.AccountStatusCode}
          />
        ),
        minWidth: 20,
      },
      {
        label: 'Fraud Status',
        orderById: 'FraudStatus',
        data: 'FraudStatus',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        // label: 'FW Office',
        label: 'Ev. Pym Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'CountryName',
        data: 'CountryName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 50,
      },
      {
        label: 'Pending On',
        orderById: 'PendingOnName',
        data: 'PendingOnName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: '# Matches',
        orderById: 'FraudMatchCount',
        data: 'FraudMatchCount',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: '# Reports',
        orderById: 'ReportCount',
        data: 'ReportCount',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: '# Not Invoiced',
        orderById: 'NotInvoicedReportCount',
        data: 'NotInvoicedReportCount',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: 'Status Change Date',
        orderById: 'LastStatusChangeDate',
        data: 'LastStatusChangeDate',
        type: FieldTypesEnum.PureDataField,
        minWidth: 100,
      },
      {
        label: ' ',
        orderById: '',
        data: FraudHitEvaluatorItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static idFunction (item)
  {
    return (
      <RedirectLinkComponent
        path='evaluator'
        tooltipText={item.ShopperId}
        isFigmaStyle={true}
        text={item.ShopperId}
        keyValuePairs={[ { key: 'Id', value: item.ShopperId } ]}
      />
    );
  }

  static getSelectedCellHeader (item)
  {
    return (
      <div>
        <input
          type='checkbox'
          checked={FraudHitEvaluatorItem.selectedStatus()}
          onChange={(e) =>
          {
            FraudHitEvaluatorItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent (item)
  {
    return (
      <div>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) =>
          {
            FraudHitEvaluatorItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static selectedStatus ()
  {
    return false;
  }

  static clickOnGlobalSelect (item, selected)
  {
    // Placeholder, don't remove it!
  }

  static clickOnSelect (item, selected)
  {
    // Placeholder, don't remove it!
  }

  static matrixFunction = (item) =>
  {
    alert('Empty function');
  };

  static fraudStatusChangeFunction = (fraudHitEvaluatorId) =>
  {
    alert('Empty function');
  };

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Matrix',
            onClick: () => FraudHitEvaluatorItem.matrixFunction(item),
            iconName: 'fa-solid fa-tasks',
            isMarkedRed: item.IsMarkedRed,
          },
          {
            text: 'Change Fraud Status',
            onClick: () => FraudHitEvaluatorItem.fraudStatusChangeFunction(item),
            iconName: 'fa-solid fa-hammer-crash',
            roleKey: 'AntiFraudTool_ActionButton',
            isMarkedRed: item.IsMarkedRed,
          },
        ]}
      />
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [ { label: 'Evaluator ID', name: 'EvaluatorId' } ],
    },
  ];
}
